export default {"src":"/_next/static/media/loanrepaycalc.8d404595.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};